import C from './constants'

export const setSolidRateValues = (values) => (
    {
        type: C.SET_SOLID_RATE_VALUES,
        payload: values
    }
)
